import { jsx as _jsx } from "react/jsx-runtime";
import { Button, buttonClasses, useTheme } from '@mui/material';
import { useState } from 'react';
export const ConfirmLoadingButton = (props) => {
    const theme = useTheme();
    const { confirmMessage, onConfirm, children, ...rest } = props;
    const [willConfirm, setWillConfirm] = useState(false);
    const handleClick = () => {
        if (willConfirm) {
            props.onConfirm();
            setWillConfirm(false);
        }
        else {
            setWillConfirm(true);
        }
    };
    const confirmStyle = willConfirm
        ? {
            color: theme.palette.error.contrastText,
            backgroundColor: theme.palette.error.main,
            borderColor: theme.palette.error.main,
        }
        : {};
    return (_jsx(Button, { ...rest, loadingPosition: "start", style: confirmStyle, sx: {
            [`& .${buttonClasses.startIcon}`]: {
                // if no start icon is set, the width unnecessarily expands
                // to make room for the loading indicator,
                // which requires the following workaround:
                display: rest.startIcon ? 'inherit' : 'none',
            },
            [`& .MuiButton-label`]: {
                display: 'inline-grid',
                verticalAlign: 'top',
                alignItems: 'center',
                position: 'relative',
                '&::before': {
                    content: `'${children.toString().replaceAll("'", "\\'")}'`,
                    visibility: 'hidden',
                    whiteSpace: 'pre-wrap',
                    width: 'auto',
                    gridRowStart: 1,
                    gridColumnStart: 1,
                },
                '&::after': {
                    content: `'${confirmMessage?.toString().replaceAll("'", "\\'")}'`,
                    visibility: 'hidden',
                    whiteSpace: 'pre-wrap',
                    width: 'auto',
                    gridRowStart: 1,
                    gridColumnStart: 1,
                },
            },
        }, onClick: handleClick, onMouseLeave: () => {
            setWillConfirm(false);
        }, onBlur: () => {
            setWillConfirm(false);
        }, children: _jsx("span", { className: 'MuiButton-label', children: _jsx("span", { style: {
                    width: 'auto',
                    paddingInline: 0,
                    gridRowStart: 1,
                    gridColumnStart: 1,
                }, children: willConfirm && confirmMessage ? confirmMessage : children }) }) }));
};
